import React from 'react';
import styled from 'styled-components';
import NeonButton from '../shared/NeonButton';
import { motion } from 'framer-motion';

const QueryAISection = styled(motion.section)`
  background-color: ${props => props.theme.colors.white};
  padding: 6rem 0;
  width: 100%;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  gap: 6rem;
`;

const LeftSection = styled.div`
  flex: 1;
`;

const RightSection = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const Logo = styled.img`
  max-width: 300px;
  height: auto;
  border-radius: ${props => props.theme.borderRadius.medium};
  transition: transform ${props => props.theme.transitions.medium};
  
  &:hover {
    transform: scale(1.05);
  }
`;

const Description = styled.p`
  font-size: 1.75rem;
  color: ${props => props.theme.colors.darkGray};
  line-height: 1.4;
  margin: 0;
  font-family: ${props => props.theme.fonts.primary};
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sm};
  margin-top: 1rem;

  .project-neon-button:hover {
    color: ${props => props.theme.colors.black};
  }
`;

const QueryAI = () => {
  return (
    <QueryAISection
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.5 }}
    >
      <Container>
        <LeftSection>
          <Logo src="/images/projects/queryai-1.jpg" alt="QueryAI Logo" />
        </LeftSection>
        <RightSection>
          <Description>
            Meet QueryAI, an AI-based customer support assistant enhancing response automation across messaging platforms.
          </Description>
          <ButtonGroup>
            <NeonButton 
              as="a" 
              href="/assets/queryai-extension-v2-082.zip"
              download
              small
              className="project-neon-button"
            >
              Download
            </NeonButton>
            <NeonButton 
              as="a" 
              href="https://dashboard.automationai.lt"
              target="_blank"
              rel="noopener noreferrer"
              small
              className="project-neon-button"
            >
              Login
            </NeonButton>
          </ButtonGroup>
        </RightSection>
      </Container>
    </QueryAISection>
  );
};

export default QueryAI; 